import { useState } from 'react'

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const SUCCESS_MESSAGE = 'Invite link resend will be enabled once the backend endpoint is ready.'

function validateEmail(email: string) {
  const normalizedEmail = email.trim()

  if (!normalizedEmail) {
    return 'Email is required.'
  }

  if (!EMAIL_PATTERN.test(normalizedEmail)) {
    return 'Please enter a valid email address.'
  }

  return null
}

export function useInviteLinkRecovery() {
  const [email, setEmail] = useState('')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [successMessage, setSuccessMessage] = useState<string | null>(null)

  const handleEmailChange = (value: string) => {
    setEmail(value)
    if (errorMessage) {
      setErrorMessage(null)
    }
    if (successMessage) {
      setSuccessMessage(null)
    }
  }

  const submit = async () => {
    const normalizedEmail = email.trim()
    const validationError = validateEmail(normalizedEmail)

    if (validationError) {
      setSuccessMessage(null)
      setErrorMessage(validationError)
      return
    }

    setErrorMessage(null)
    setSuccessMessage(SUCCESS_MESSAGE)
  }

  return {
    email,
    errorMessage,
    handleEmailChange,
    isSubmitting: false,
    submit,
    successMessage
  }
}
